





























































































































































import { Component, Vue } from "vue-property-decorator";
import { InputTypes } from "@/components/gitlify/GitlifyTextInputTypes";
/**
 * the demo components must be registered globally!!
 * ensure you don't import theme here but in the plugins
 * gitlify-form-components.ts
 */

@Component
/**
 * A demo page showing of the
 * custom gitlify form components
 */
export default class Login extends Vue {
  public models = {
    textInputTypes: Object.values(InputTypes),
    textInputType: "text",
    textInputVal: "A sample text",
    textAreaVal: "A text area",
    markdownText: "This is **some** markdown \n * n1 \n * n2",
    imageUpload: "",
    selectMultipleCheckbox: false,
    select: "",
    selectOptions: [
      { value: null, text: "Please select an option" },
      { value: "a", text: "This is First option" },
      { value: "b", text: "Selected Option" },
      { value: { C: "3PO" }, text: "This is an option with object value" },
      { value: "d", text: "This one is disabled", disabled: true },
    ],
    checkbox: null,
    timePicker: null,
    datePicker: null,
    dateTimePicker: null,
    tags: null,
    predefinedTags: null,
    availableTags: ["banana", "orange", "tomato"],
    fileUploads: null,
  };
}
